import CampusConnect from "../assets/images/campusconnect.png"
import { Link } from "react-router-dom";
import Footer from "../components/footer";

export default function Ambassador () {
    return (
        <div class="w-full sm:w-1/3">
            <div class="w-full mt-8 flex flex-row justify-around">
               <div class="text-4xl w-5/12">
                   <p>horsey</p>
               </div>
               <Link class="w-3/12 rounded pt-1 h-8 bg-blue-700" to="/beforeSignUp">
               <div class="w-full text-white text-center font-light">
                   <p>Sign In</p>
               </div>
               </Link>
           </div>
           <div class="w-full mb-4 flex">
            <div class="w-4/12"></div>
            <div class="w-3/12">
                <p>beta</p>
            </div>
           </div>

           <div class="h-4 w-full"/>
           
            <div class="pl-8 text-3xl my-4 dtwo">CAMPUS AMBASSADOR PROGRAM</div>
            <div class="my-12 flex"><img class="m-auto w-10/12" src={CampusConnect} /></div>
            <div class="flex mb-4"><div class="m-auto w-10/12 text-lg">If you are interested in being the person responsible to spread the correct information, be the person who people clarify doubts about horsey from and take up any practical new task. </div></div>
            <div class="ml-7 my-2 text-lg">We have upto 2 openings per college. </div>
            <div class="ml-8 mt-8 mb-4 text-sm dtwo">Renumeration:</div>
            <div class="mx-8 my-1">You will be paid the subscription amount of last day of every month of your college.</div>
            <div class="ml-8 mt-8 mb-4 text-sm dtwo">Interview Process:</div>
            <ul class="list-disc mx-12 mb-2">
                <li>2nd Year </li>
                <li>Access to laptop, smartphone</li>
                <li>A desire to grow the subscriber base</li>
                <li>A passion towards entrepreneurship</li>
            </ul>
            <div class="ml-8 mt-8 mb-4 text-sm dtwo">Performance Review:</div>
            <div class="mx-8 mb-2">Every 3 months or earlier in case of any misconduct.</div>
            <div class="h-16"></div>
            <Footer/>
        </div>  
    );
}